import {capitalize} from "lodash";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
	props: {
		product: {
			type: Object,
			required: true
		}
	},
	computed: {
		...mapGetters(['language', 'lang'])
	},
	methods: {
		/**
		 * Extracts the product property based on the given property name and language strictness.
		 * If langStrict is true, it returns the language-specific property value if it exists, or an empty string if it doesn't.
		 * If langStrict is false, it tries to find the specified language-specific property if it exists,
		 * otherwise it returns the default property value if it exists, or an empty string if neither exist.
		 *
		 * @param {string} prop - The name of the property to extract.
		 * @param {boolean} langStrict - Determines the language strictness. If true, it only returns the language-specific property value if it exists. If false, it falls back to the default property value if the language-specific property doesn't exist.
		 * @returns {string} - The extracted product property value.
		 */
		extractProductProp(prop, langStrict = false) {
			const lang = this.config?.props?.[prop]?.lang || this.language;
			//const lang =  this.config?.props ? (this.config?.props[prop]?.lang || this.language) : this.language;
			//langStrict if true gets language locale only version of property if it exists, if false it tries to find either if specified language local doesn't exist
			const strict = this.product?.[`${prop}${capitalize(lang)}`] || this.product?.[prop];
			const loose = this.product?.[`${prop}En`] || this.product?.[`${prop}Fr`];
			if (langStrict) {
				return strict || '';
			}
			return strict || loose || '';
		},
		formatCurrency(currency) {
			const lang = this.language;
			if (currency === null || currency === undefined) return;

			const str = String(currency).replaceAll('$', '');

			const regex = /\d+([.,])\d{2}/g;

			const replacedString = str.replace(regex, (match) => {
				if (lang === 'fr') {
					match = match.replace('.', ',') + '$';
				} else {
					match = '$' + match.replace(',', '.');
				}
				return match;
			});
			if (replacedString === str)
				return String(currency)

			return replacedString
		},
		formatDate(date) {
			return moment.utc(date).locale(this.language).format(this.language === 'en' ? 'MMMM D, YYYY' : 'D MMMM, YYYY');
		},

		/**
		 * Retrieves the validity date of a specified property from the product object (UTC).
		 *
		 * @param {string} prop - The name of the property whose validity date is to be fetched.
		 * @return {Moment|undefined} Returns a Moment.js object representing the validity date if the property exists; otherwise, returns undefined.
		 */
		getAsDate(prop) {
			const date = this.extractProductProp(prop);
			if (date) {
				return moment.utc(date)
			}
		}
	}
}
